import { useTranslation } from 'react-i18next';
import ConsentContent from './consent-content';
import useChat from '../../hooks/use-chat';
import { cn, shouldUseSessionStorage } from '../../lib/utils';
import { CURRENT_INSTANCE } from '../../tenant';
import { Button } from '../ui/button';

function ConsentOverlay() {
  const { setShowAgreementBanner, setAgreedToDisclaimer, setAgreedToDisclaimerPerSession } =
    useChat();
  const { t } = useTranslation();

  function handleAgree() {
    if (shouldUseSessionStorage()) setAgreedToDisclaimerPerSession(true);
    else setAgreedToDisclaimer(true);
    setShowAgreementBanner(false);
  }
  function handleDisagree() {
    setShowAgreementBanner(false);
  }

  const consentBg =
    CURRENT_INSTANCE.theme.classes?.consent?.background ?? 'bg-[hsl(var(--xircle-main))]';

  return (
    <div className="absolute inset-0 w-full h-full z-10 bg-slate-950/40 backdrop-blur-sm">
      <div
        className={cn(
          'w-[92%] sm:w-4/5 max-w-3xl rounded-2xl p-6 mx-auto mt-6 text-white shadow-2xl border border-white/10',
          consentBg
        )}
      >
        <div className="max-h-[55vh] overflow-y-auto pr-2 custom-scroll">
          <ConsentContent />
        </div>
        <div className="w-full flex flex-col sm:flex-row justify-center items-center gap-3 mt-6">
          <Button
            className="bg-white text-slate-900 border-none text-sm uppercase shadow-md px-6"
            size="lg"
            onClick={handleAgree}
          >
            {t('agreement_banner.agree_button')}
          </Button>
          <Button
            className="bg-transparent border border-white/40 text-white text-sm uppercase shadow-md px-6"
            size="lg"
            onClick={handleDisagree}
          >
            {t('agreement_banner.disagree_button')}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ConsentOverlay;
